import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SavedQueriesModel } from '../../../models/filter-model';
import { VennHealthDataService } from '../../../services/vennhealth-data.service';
import { VennHealthDialogService } from '../../../services/vennhealth-dialog.service';
import { SharedService } from '../../../services/shared.service';
import { IndicationGroup } from '@app/models/indication';
import { VennHealthHelpers } from '@app/shared/vennHealthHelpers';

@Component({
  selector: 'app-saved-filters',
  templateUrl: './saved-filters.component.html',
  styleUrls: ['./saved-filters.component.css']
})
export class SavedFiltersComponent implements OnInit {

  loading = false;
  savedQueriesData: SavedQueriesModel[] = [];
  allIndications: IndicationGroup[] = [];

  constructor(
    private readonly vennHealthDataService: VennHealthDataService,
    private readonly ngxSpinner: NgxSpinnerService,
    private readonly sharedService: SharedService,
    private readonly vennHealthDialogService: VennHealthDialogService
  ) { }

  ngOnInit(): void {
    this.ngxSpinner.show('savedQueriesSpinner');
    this.refreshSavedQueriesSubscription();

    this.sharedService.allIndications.subscribe(data => {
      if (data) {
        this.allIndications = data;
      }
    });

    this.sharedService.refreshSavedQueries.subscribe(data => {
      if (data !== null && data === true) {
        this.refreshSavedQueriesSubscription();
      }
    });
  }

  refreshSavedQueriesSubscription(): void {
    this.loading = true;
    this.vennHealthDataService.getClientSavedFilterNamesList().subscribe({
      next: (response) => {
        if (response !== null) {
          this.savedQueriesData = response;
        }
      },
      error: (e) => { 
        this.ngxSpinner.hide('savedQueriesSpinner');
        this.loading = false;
      },
      complete: () => {
        this.ngxSpinner.hide('savedQueriesSpinner');
        this.loading = false;
      }
    });
  }

  loadSavedQuery(dataItem: any): void {
    this.vennHealthDataService.getSavedFilter(dataItem.queryId).subscribe({
      next: (data) => {
        if (data) {
          this.allIndications.forEach(group => {
            group.indications.forEach(i => {
              let savedIndication = VennHealthHelpers.getCurrentIndicationFromIndicationGroupJson(i, data.indicationGroups);
              // update only the selected and selections properties so we retain the inputOptions, labels, ect used by the UI only
              if (savedIndication) {
                i.selected = savedIndication['selected'];
                i.selections = savedIndication['selections'];
              }
            });
          });
          this.sharedService.setAllIndications(this.allIndications);
          this.sharedService.setActiveSavedFilters(data);
          this.sharedService.setSeletedDataSets(data.dataSets);
          this.sharedService.setActiveQueryName(data.queryName);
          this.sharedService.setActiveQueryId(data.queryId);
        }
      },
      error: (e) => {
        this.vennHealthDialogService.showOkDialog('Query Load Failed',
        `Query filters for ${dataItem.queryName} failed to load properly.`);
      },
      complete: () => {
        console.info('complete query details get');
      }
    });
  }

}
